jQuery(document).ready(function ($) {
  
// function updateDotsBySkud(skud) {
//   var $carousel = $('.slider-gallery-product-custom .flickityt4s');
//   if ($carousel.length === 0 || !skud) return;

//   var $allSlides = $carousel.find('.t4s-product__media-item');
//   var matchedIndexes = [];

//   $allSlides.each(function (index) {
//     var imageCheck = $(this).data('image-check');
//     if (imageCheck && imageCheck.includes(skud)) {
//       matchedIndexes.push(index);
//     }
//   });

//   var $dots = $('.flickityt4s-page-dots li');
//   $dots.each(function () {
//     var ariaLabel = $(this).attr('aria-label');
//     var match = ariaLabel && ariaLabel.match(/Page dot (\d+)/);
//     if (match) {
//       var dotIndex = parseInt(match[1], 10) - 1;
//       if (matchedIndexes.includes(dotIndex)) {
//         $(this).show();
//       } else {
//         $(this).hide();
//       }
//     } else {
//       $(this).hide(); 
//     }
//   });
// }


// function getSelectedSkud() {
//   var $selectedOption = $('.selection-variant-custom option:selected');
//   return $selectedOption.data('skud');
// }

// $(document).ready(function () {
//   var initialSkud = getSelectedSkud();
//   updateDotsBySkud(initialSkud);

//   var carousel = document.querySelector('.slider-gallery-product-custom .flickityt4s');
//   if (carousel) {
//     var observer = new MutationObserver(function () {
//       var skud = getSelectedSkud();
//       updateDotsBySkud(skud);
//     });

//     observer.observe(carousel, {
//       childList: true,
//       subtree: true,
//       attributes: true,
//       attributeFilter: ['class', 'data-image-check']
//     });
//   }

//   $(document).on('click', '.t4s-swatch__list .swatch-color-custom', function () {
//     setTimeout(function () {
//       var skud = getSelectedSkud();
//       updateDotsBySkud(skud);
//     }, 50);
//   });

//   $(document).on('change', '.selection-variant-custom', function () {
//     var skud = getSelectedSkud();
//     updateDotsBySkud(skud);
//   });
// });

function updateDotsBySkud(skud) {
    var $carousel = $('.slider-gallery-product-custom .flickityt4s');
    if ($carousel.length === 0 || !skud) return;

    var $allSlides = $carousel.find('.t4s-product__media-item');

    var hasVideo = $allSlides.filter(function () {
      return $(this).data('media-type') === 'video';
    }).length > 0;

    if (hasVideo) {
      return; 
    }

    var matchedIndexes = [];
    $allSlides.each(function (index) {
      var imageCheck = $(this).data('sku');
      if (imageCheck && imageCheck == skud) {
        matchedIndexes.push(index);
      }
    });

    var $dots = $('.flickityt4s-page-dots li');
    $dots.each(function () {
      var ariaLabel = $(this).attr('aria-label');
      var match = ariaLabel && ariaLabel.match(/Page dot (\d+)/);
      if (match) {
        var dotIndex = parseInt(match[1], 10) - 1;
        if (matchedIndexes.includes(dotIndex)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      } else {
        $(this).hide();
      }
    });
}


function getSelectedSkud() {
  var $selectedOption = $('.selection-variant-custom option:selected');
  return $selectedOption.data('skud');
}

$(document).ready(function () {
  var initialSkud = getSelectedSkud();
  updateDotsBySkud(initialSkud);

  var carousel = document.querySelector('.slider-gallery-product-custom .flickityt4s');
  if (carousel) {
    var observer = new MutationObserver(function () {
      var skud = getSelectedSkud();
      updateDotsBySkud(skud);
    });

    observer.observe(carousel, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-sku']
    });
  }

  $(document).on('click', '.t4s-swatch__list .swatch-color-custom', function () {
    setTimeout(function () {
      var skud = getSelectedSkud();
      updateDotsBySkud(skud);
    }, 50);
  });

  $(document).on('change', '.selection-variant-custom', function () {
    var skud = getSelectedSkud();
    updateDotsBySkud(skud);
  });
});

$(document).ready(function () {
  // Run once on load
 var initialSkud = getSelectedSkud();
  updateSlidesBySkud(initialSkud);

  // Watch for DOM changes in the carousel to auto-update dots
  var carousel = document.querySelector('.slider-gallery-product-custom .flickityt4s');
  if (carousel) {
    var observer = new MutationObserver(function () {
      var skud = getSelectedSkud();
      updateSlidesBySkud(skud);
    });

    observer.observe(carousel, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-sku']
    });
  }

  // Update dots when color swatch is clicked
  $(document).on('click', '.t4s-swatch__list .swatch-color-custom', function () {
    setTimeout(function () {
      var skud = getSelectedSkud();
      updateSlidesBySkud(skud);
    }, 50);
  });

  // Update dots when variant dropdown changes
  $(document).on('change', '.selection-variant-custom', function () {
    var skud = getSelectedSkud();
    updateDotsBySkud(skud);
  });
});

  $(document).on(
    "click",
    ".t4s-page_cart__edit, .t4s-mini_cart__edit",
    function () {
      var properties = $(this).data("properties");
      var variant_id = $(this).data("variant-id");
      var key_variant = $(this).data("key_variant");
      const intervalId = setInterval(function () {
        const $container = $(".t4s-product-quick-shop .t4s-form__product");
        var option_name = $container.find(".t4s-swatch").data("option-name");
        if ($container.length > 0) {
          $(
            '.t4s-product-quick-shop .t4s-form__product input[name="properties_check"]'
          ).val(properties);
          $(
            '.t4s-product-quick-shop .t4s-form__product input[name="variant_id_check"]'
          ).val(variant_id);
          $(
            '.t4s-product-quick-shop .t4s-form__product input[name="key_variant"]'
          ).val(key_variant);
          if (option_name != "Taille" && option_name != "Size") {
            $(".t4s-product-quick-shop .format-two-decimals").each(function () {
              let text = $(this).text().trim();

              if (!/^\d+,?\d*$/.test(text)) {
                return;
              }

              let parts = text.split(",");
              let integerPart = parts[0];
              let decimalPart = parts[1] || "00";

              if (decimalPart.length === 1) {
                decimalPart += "0";
              }

              let formattedNumber = integerPart + "," + decimalPart;
              $(this).text(formattedNumber);
            });
          }

          updateTailleValue();
          updateTailleValueEnglish();
          clearInterval(intervalId);
        }
      }, 200);
    }
  );
  $(document).on(
    "click",
    ".t4s-modal .t4s-product-quick-shop .t4s-form__product .wrap-product-form-custom .replace-button-form",
    function (e) {
      e.preventDefault();
      var $form = $(".t4s-modal .t4s-product-quick-shop .t4s-form__product");
      var $btn = $(this);
      var $spinner = $btn.find(".t4s-loading__spinner");
      var $svg = $spinner.find("svg");

      $spinner.removeAttr("hidden");
      $svg.removeAttr("hidden");

      var variantIdCheck = $.trim(
        $form.find('input[name="variant_id_check"]').val()
      );
      var key_variant = $.trim($form.find('input[name="key_variant"]').val());
      var variantIdModalChoose = $.trim(
        $form.find('input[name="variant_id_modal_choose"]').val()
      );
      var propertiesCheck = $.trim(
        $form.find('input[name="properties_check"]').val()
      );
      var propertiesModalChoose = $.trim(
        $form.find('input[name="properties_modal_choose"]').val()
      );

      var submitForm = function () {
        $spinner.removeAttr("hidden");
        $svg.removeAttr("hidden");
        $form.find(".t4s-product-form__submit").trigger("click");
      };

      if (
        variantIdCheck &&
        variantIdCheck === variantIdModalChoose &&
        propertiesCheck !== propertiesModalChoose
      ) {
        $.getJSON("/cart.js", function (cart) {
          var itemToRemove = null;
          $.each(cart.items, function (i, item) {
            if (
              item.variant_id == variantIdCheck &&
              item.properties &&
              item.properties["taille"] == propertiesCheck
            ) {
              itemToRemove = item;
              return false;
            }
          });

          if (itemToRemove) {
            $.ajax({
              type: "POST",
              url: "/cart/change.js",
              dataType: "json",
              contentType: "application/json",
              data: JSON.stringify({
                id: itemToRemove.key,
                quantity: 0,
              }),
              success: function (response) {
                submitForm();
              },
              error: function (xhr, status, error) {
                console.error("error:", error);
                $spinner.attr("hidden", true);
                $svg.attr("hidden", true);
              },
            });
          } else {
            submitForm();
          }
        }).fail(function () {
          $spinner.attr("hidden", true);
          $svg.attr("hidden", true);
        });
      } else {
        submitForm();
      }
    }
  );

  $(document).ready(function () {
    $.getJSON("/cart.js", function (cart) {
      var zeroPriceItems = cart.items.filter(function (item) {
        return item.final_line_price === 0;
      });

      if (zeroPriceItems.length === 0) return;

      var ajaxCalls = [];

      zeroPriceItems.forEach(function (item) {
        var request = $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: JSON.stringify({
            id: item.key,
            quantity: 0,
          }),
          dataType: "json",
          contentType: "application/json",
        });

        request.done(function () {
          console.log("Removed product with price = 0:", item.product_title);
        });

        ajaxCalls.push(request);
      });

      $.when.apply($, ajaxCalls).then(function () {
        const event = new Event("cart:refresh");
        document.dispatchEvent(event);
        console.log("cart:refresh dispatched");
      });
    });
  });

  $(document).ready(function () {
    const $container = $(".t4s-swatch__list_3 .list_1");
    const $items = $container.find(".t4s-swatch__item_diametre").get();

    $items.sort(function (a, b) {
      const valA = parseFloat($(a).data("value").toString().replace(",", "."));
      const valB = parseFloat($(b).data("value").toString().replace(",", "."));
      return valA - valB;
    });

    $.each($items, function (index, item) {
      $container.append(item);
    });
  });
  $(document).on(
    "click",
    ".t4s-page_cart__edit, .t4s-mini_cart__edit",
    function () {
      const intervalId = setInterval(function () {
        const $container = $(
          ".t4s-modal .t4s-product-quick-shop .t4s-swatch__list_3 .list_1"
        );

        if (
          $container.length > 0 &&
          $container.find(".t4s-swatch__item_diametre").length > 0
        ) {
          const $items = $container.find(" .t4s-swatch__item_diametre").get();

          $items.sort(function (a, b) {
            const valA = parseFloat(
              $(a).data("value").toString().replace(",", ".")
            );
            const valB = parseFloat(
              $(b).data("value").toString().replace(",", ".")
            );
            return valA - valB;
          });

          $.each($items, function (index, item) {
            $container.append(item);
          });

          clearInterval(intervalId);
        }
      }, 200);
    }
  );

  function initOrDestroySlider() {
    var $slider = $(
      ".section-actualites-custom.t4s-row,.custom-news-section.t4s-row"
    );

    if (window.innerWidth <= 768) {
      if (!$slider.hasClass("slick-initialized")) {
        $slider.slick({
          slidesToShow: 1.5,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: false,
          lazyLoad: "ondemand",
        });
      }
    } else {
      if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }
    }
  }

  initOrDestroySlider();

  $(window).on("resize", function () {
    initOrDestroySlider();
  });

  if ($(".selection-variant-custom option").length === 1) {
    $(".selection-variant-custom").trigger("change");
  }
  $(".t4s-page_cart__edit").on("click", function () {
    setTimeout(function () {
      if ($(".selection-variant-custom option").length === 1) {
        $(".selection-variant-custom").trigger("change");
      }
    }, 500);
  });
  $(".t4s-mini_cart__edit").on("click", function () {
    setTimeout(function () {
      if ($(".selection-variant-custom option").length === 1) {
        $(".selection-variant-custom").trigger("change");
      }
    }, 500);
  });
  function updateTailleValue() {
    var selectedInput = $(
      '.taille-cubiste input[name="properties[taille]"]:checked'
    );
    if (selectedInput.length > 0) {
      var selectedValue = selectedInput.val();
      $(
        '.t4s-product-quick-shop .t4s-form__product input[name="properties_modal_choose"]'
      ).val(selectedValue);
    }
  }
  function updateTailleValueEnglish() {
    var selectedInput = $(
      '.taille-cubiste input[name="properties[size]"]:checked'
    );
    if (selectedInput.length > 0) {
      var selectedValue = selectedInput.val();
      $(
        '.t4s-product-quick-shop .t4s-form__product input[name="properties_modal_choose"]'
      ).val(selectedValue);
    }
  }
  $(document).on(
    "change",
    '.taille-cubiste input[name="properties[size]"]',
    function () {
      updateTailleValueEnglish();
    }
  );
  $(document).on(
    "change",
    '.taille-cubiste input[name="properties[taille]"]',
    function () {
      updateTailleValue();
    }
  );

  $(document).ready(function () {
    setTimeout(function () {
      var selectedOption = $(".selection-variant-custom option:selected");
      var price = selectedOption.data("price");
      if (price === "0 €" || price === "0" || price === 0) {
        $(".t4s-product-form__buttons .t4s-product-form__quote").attr(
          "style",
          "display: flex !important"
        );
        $(".t4s-product-form__buttons .t4s-product-form__submit").attr(
          "style",
          "display: none !important"
        );
        $(
          ".t4s-product-quick-shop .t4s-product-form__buttons .shopify-payment-button"
        ).attr("style", "display: none");
        $(".t4s-sticky-atc__atc.t4s-sticky-none-price").attr(
          "style",
          "display: block"
        );
        $(".t4s-sticky-atc__atc.t4s-sticky-yes-price").attr(
          "style",
          "display: none"
        );
        var lang = $("html").attr("lang");
        if(lang !== 'fr'){
          setTimeout(function () {
            $(".t4s-product-form__buttons .t4s-product-form__quote").text('REQUEST A QUOTE');
            $(".t4s-sticky-atc__btns .t4s-sticky-none-price span").text('REQUEST A QUOTE');
          },1000);
        }
      } else {
        $(".t4s-product-form__buttons .t4s-product-form__quote").attr(
          "style",
          "display: none !important"
        );
        $(".t4s-product-form__buttons .t4s-product-form__submit").attr(
          "style",
          "display: flex !important; opacity: 1 !important;"
        );
        $(
          ".t4s-product-quick-shop .t4s-product-form__buttons .t4s-product-form__submit"
        ).attr("style", "display: none !important;");
        $(
          ".t4s-product-quick-shop .t4s-product-form__buttons .shopify-payment-button"
        ).attr("style", "display: block ");
        $(".t4s-sticky-atc__atc.t4s-sticky-none-price").attr(
          "style",
          "display: none"
        );
        $(".t4s-sticky-atc__atc.t4s-sticky-yes-price").attr(
          "style",
          "display: block"
        );
      }
    }, 500);
  });
  // $(document).on('click', '.button-custom-request-for-quote', function() {
  //   var variantId = $('.selection-variant-custom option:selected').data('id-variant');
  //   console.log('variantId',variantId)
  //   if (variantId) {
  //     GRFQApp.addProduct(this, variantId);
  //   }
  // });

  $(document).on("change", ".selection-variant-custom", function () {
    var selectedOption = $(this).find("option:selected");
    var variantId = selectedOption.data("id-variant");
    var price = selectedOption.data("price");
    var priceDefault = selectedOption.data("price-default");
    var collectionSale = selectedOption.data("price-sale");
    var productSale = selectedOption.data("product-sale");
    var image = selectedOption.data("image");
    var title = selectedOption.data("title");
    var handle = selectedOption.data("handle");
    $(
      '.t4s-product-quick-shop .t4s-form__product input[name="variant_id_modal_choose"]'
    ).val(variantId);
    var priceSale = priceDefault - priceDefault * 0.3 + " €";
    if (price === "0 €" || price === "0" || price === 0) {
      var lang = $("html").attr("lang");
      var text_request = "Prix sur demande"
      if(lang === 'fr'){
        var text_request = 'Prix sur demande';
      }else{
        var text_request = 'Price on request';
      }
      $(".t4s-product-price-paypal .price-custom-single .price-custom").text(
        text_request
      );
      $(".t4s-product-form__buttons .t4s-product-form__quote").attr(
        "style",
        "display: flex !important"
      );
      $(".t4s-product-form__buttons .t4s-product-form__submit").attr(
        "style",
        "display: none !important"
      );
      $(".t4s-sticky-atc__atc.t4s-sticky-none-price").attr(
        "style",
        "display: block"
      );
      $(".t4s-sticky-atc__atc.t4s-sticky-yes-price").attr(
        "style",
        "display: none"
      );
      $(
        ".t4s-product-quick-shop .t4s-product-form__buttons .shopify-payment-button"
      ).attr("style", "display: none");
      var lang = $("html").attr("lang");
      if(lang !== 'fr'){
        setTimeout(function () {
            $(".t4s-product-form__buttons .t4s-product-form__quote").text('REQUEST A QUOTE');
          $(".t4s-sticky-atc__btns .t4s-sticky-none-price span").text('REQUEST A QUOTE');
          },500);
      }
    } else {
      $(".t4s-product-form__buttons .t4s-product-form__quote").attr(
        "style",
        "display: none !important"
      );
      $(".t4s-product-form__buttons .t4s-product-form__submit").attr(
        "style",
        "display: flex !important; opacity: 1 !important;"
      );
      $(
        ".t4s-product-quick-shop .t4s-product-form__buttons .t4s-product-form__submit"
      ).attr("style", "display: none !important;");
      $(".t4s-sticky-atc__atc.t4s-sticky-none-price").attr(
        "style",
        "display: none"
      );
      $(".t4s-sticky-atc__atc.t4s-sticky-yes-price").attr(
        "style",
        "display: block"
      );
      $(
        ".t4s-product-quick-shop .t4s-product-form__buttons .shopify-payment-button"
      ).attr("style", "display: block");

      if (collectionSale === "priceSale") {
        $(".t4s-product-price-paypal .price-custom-single .price-custom").html(
          '<span class="price-default-custom">' +
            price +
            "</span>" +
            '<span class="price-sale-custom">' +
            priceSale +
            "</span>"
        );
      } else {
        $(".t4s-product-price-paypal .price-custom-single .price-custom").text(
          price
        );
      }
    }

    $(".wishlist-custom").attr({
      "data-id": variantId,
      "data-price": price,
      "data-price-sale": priceSale,
      "data-product-sale": productSale,
      "data-image": image,
      "data-title": title,
      "data-handle": handle,
    });
    var wishlist = JSON.parse(localStorage.getItem("wishlistItems")) || [];
    var isActive = wishlist.some(function (item) {
      return String(item.dataId) === String(variantId);
    });

    if (isActive) {
      $(".wishlist-custom").addClass("active");
    } else {
      $(".wishlist-custom").removeClass("active");
    }
  });
  // $('.selection-variant-custom').on('change', function () {

  // });
  function updateWishlistCount() {
    var wishlist = JSON.parse(localStorage.getItem("wishlistItems")) || [];
    $(".custom-icon-wishlist .count-wishlist-custom").text(wishlist.length);
  }
  $(document).ready(function () {
    updateWishlistCount();
  });
  $(document).on("click", ".wishlist-custom", function () {
    var $this = $(this);
    var variantId = $this.attr("data-id");
    if (!variantId) return;

    var wishlist = JSON.parse(localStorage.getItem("wishlistItems")) || [];

    if ($this.hasClass("active")) {
      wishlist = wishlist.filter(function (item) {
        return item["dataId"].toString() !== variantId.toString();
      });
      localStorage.setItem("wishlistItems", JSON.stringify(wishlist));
      $this.removeClass("active");
      updateWishlistCount();
    } else {
      var price = $this.attr("data-price");
      var priceSale = $this.attr("data-price-sale");
      var productSale = $this.attr("data-product-sale");
      var image = $this.attr("data-image");
      var title = $this.attr("data-title");
      var handle = $this.attr("data-handle");

      var exists = wishlist.some(function (item) {
        return item["dataId"].toString() === variantId.toString();
      });

      if (!exists) {
        wishlist.push({
          dataId: variantId,
          dataPrice: price,
          dataPriceSale: priceSale,
          dataProductSale: productSale,
          dataImage: image,
          dataTitle: title,
          dataHandle: handle,
        });
        localStorage.setItem("wishlistItems", JSON.stringify(wishlist));
        $this.addClass("active");
        updateWishlistCount();
      }
    }
  });

  function updateWishlistState() {
    var wishlist = JSON.parse(localStorage.getItem("wishlistItems")) || [];

    $(".wishlist-collection-custom").each(function () {
      var $container = $(this);
      var dataId = $container
        .find(".add-wishlist-in-collection")
        .attr("data-id");

      var isInWishlist = wishlist.some(function (item) {
        return String(item.dataId) === String(dataId);
      });

      if (isInWishlist) {
        $container.addClass("active");
      } else {
        $container.removeClass("active");
      }
    });

    $(".custom-icon-wishlist .count-wishlist-custom").text(wishlist.length);
  }
  $(document).on("click", ".add-wishlist-in-collection", function () {
    var $btn = $(this);
    var $container = $btn.closest(".wishlist-collection-custom");

    var dataId = $btn.attr("data-id");
    var dataTitle = $btn.attr("data-title");
    var dataPrice = $btn.attr("data-price");
    var dataPriceSale = $btn.attr("data-price-sale");
    var dataProductSale = $btn.attr("data-product-sale");
    var dataImage = $btn.attr("data-image");
    var dataHandle = $btn.attr("data-handle");

    var wishlist = JSON.parse(localStorage.getItem("wishlistItems")) || [];

    var exists = wishlist.some(function (item) {
      return String(item.dataId) === String(dataId);
    });

    if (!exists) {
      wishlist.push({
        dataId: dataId,
        dataTitle: dataTitle,
        dataPrice: dataPrice,
        dataPriceSale: dataPriceSale,
        dataProductSale: dataProductSale,
        dataImage: dataImage,
        dataHandle: dataHandle,
      });

      localStorage.setItem("wishlistItems", JSON.stringify(wishlist));
      $container.addClass("active");
      updateWishlistState();
    }
  });

  $(document).on("click", ".remove-wishlist-in-collection", function () {
    var $btn = $(this);
    var $container = $btn.closest(".wishlist-collection-custom");
    var dataId = $btn.attr("data-id");

    var wishlist = JSON.parse(localStorage.getItem("wishlistItems")) || [];

    wishlist = wishlist.filter(function (item) {
      return String(item.dataId) !== String(dataId);
    });

    localStorage.setItem("wishlistItems", JSON.stringify(wishlist));
    $container.removeClass("active");
    updateWishlistState();
  });

  updateWishlistState();

  $(document).on("click", ".grfq-page-products .grfq-product-info .grfq-product-duplicate", function () {
   updateTextTranslationsQuote();
  });
  $(document).on("click", ".grfq-variant-quantity-icon", function () {
    updateTextTranslationsQuote();
  });
  $(document).ready(function() {
      updateTextTranslationsQuote();
  });
  function updateTextTranslationsQuote() {
    if ($("html").attr("lang") === "en") {
      $('.rfq_form_page .grfq-page-wrapper .grfq-page-form .grfq-form-card .grfq-form-header p').text('Request for form');
      $('.rfq_form_page .grfq-quote-empty .grfq-thankyou-text .grfq-thankyou-subheading').text('Your quote is currently empty');
      $('.rfq_form_page .grfq-quote-empty .grfq-continue-shopping a').text('Continue shopping');
      $('.rfq_form_page .grfq-quote-empty .grfq-continue-shopping a').attr('href', '/en/collections/all');
      $('.rfq_form_page .grfq-page-wrapper .grfq-page-form .grfq-form-card .grfq-card-wrapper .rfq_form #submitRFQForm').text('Submit');
      $('.rfq_form_page .grfq-page-wrapper .grfq-page-products .grfq-product-card .grfq-products-header .grfq-group_edit-header .grfq-group_name_text').text('Product');
      $('.rfq_form_page .grfq-page-wrapper .grfq-page-products .grfq-product-card .grfq-products-header .grfq-group_edit-header .grfq-input-group input').val('Product');
      $('.rfq_form_page .grfq-page-wrapper .grfq-page-form .grfq-form-card .grfq-card-wrapper .rfq_form .grfq-form-group #name').attr('placeholder', 'Enter your name');
      $('.rfq_form_page .grfq-page-wrapper .grfq-page-form .grfq-form-card .grfq-card-wrapper .rfq_form .grfq-form-group #email').attr('placeholder', 'Enter your email address');
      $('.rfq_form_page .grfq-page-wrapper .grfq-page-form .grfq-form-card .grfq-card-wrapper .rfq_form .grfq-form-group #phone__1724926594202').attr('placeholder', 'Phone number');
      $('.rfq_form_page .grfq-page-wrapper .grfq-page-form .grfq-form-card .grfq-card-wrapper .rfq_form .grfq-form-group #message').attr('placeholder', 'Message or question');
      $('.rfq_form_page .grfq-page-wrapper .grfq-page-form .grfq-form-card .grfq-card-wrapper .rfq_form .grfq-form-group label[for="name"]').html(`Name  <span class="grfq-required-asterisk"> *</span>`);
      $('.rfq_form_page .grfq-page-wrapper .grfq-page-form .grfq-form-card .grfq-card-wrapper .rfq_form .grfq-form-group label[for="phone__1724926594202"]').html(`Phone  <span class="grfq-required-asterisk"> *</span>`);
      $('.rfq_form_page .grfq-page-wrapper .grfq-page-products .grfq-product-card .grfq-product-table .grfq-product-info .grfq-variant-title[data-key="taille"]').each(function () {
          $(this).attr('data-key', 'size');
          $(this).find('.grfq-option-key').each(function(index) {
              if (index === 0 && $(this).text().toLowerCase().includes('taille')) {
                  $(this).text('Size:');
              }
          });
      });
      $('.rfq_form_page .grfq-page-wrapper .grfq-page-products .grfq-product-card .grfq-product-table .grfq-product-info .grfq-variant-quantity .grfq-variant-quantity-wrapper label').text('Quantity');
      $('.rfq_form_page .grfq-page-wrapper .grfq-page-products .grfq-product-card .grfq-product-table .grfq-product-footer .grfq-continue-shopping a').text('Continue shopping');
    }else{
      setTimeout(function () {
      $('.rfq_form_page .grfq-page-wrapper .grfq-page-form .grfq-form-card .grfq-collapsible-title').text('Infos supplémentaires');
      $('.grfq-page-products-add-group .grfq-btn-add-group-product span').text('Créer un devis segmenté');}, 600);
    }
  }

  $(window).on("load", function () {
    if ($("html").attr("lang") === "en") {
      setTimeout(function () {
        const host = document.querySelector("#app-embed");
        if (host) {
          const shadow = host.shadowRoot;

          if (!shadow) return;

          const heading = shadow.querySelector("._textHeading_2aowh_35");
          const firstName = shadow.querySelector("#label-first_name");
          const lastName = shadow.querySelector("#label-last_name");
          const phoneNumber = shadow.querySelector("#label-phone_number");
          const messageTxt = shadow.querySelector(
            "#label-custom\\#votre_demande"
          );
          const rfrence = shadow.querySelector(
            "#label-custom\\#rfrence"
          );
          const labelFile = shadow.querySelector("form ._textBody_2aowh_10");
          const descriptionTitle = shadow.querySelector(
            "div._textBody_2aowh_10 p"
          );
          const button = shadow.querySelector("button[data-testid='btn-form-submit']");
          const submit = shadow.querySelector("._formSubmitButton_yixuf_77");

          if (heading) heading.textContent = "CONTACT FORM";
          if (firstName) firstName.textContent = "First name *";
          if (lastName) lastName.textContent = "Last name *";
          if (phoneNumber) phoneNumber.textContent = "Phone";
          if (messageTxt) messageTxt.textContent = "Your comment or question";
          if (rfrence) rfrence.textContent = "Reference";
          if (labelFile) labelFile.textContent = "Select the files";
          if (button) button.textContent = "Send";
          if (submit) submit.textContent = "Send";
          if (descriptionTitle)
            descriptionTitle.textContent =
              "Submit your request by filling out the form below";

          const labels = shadow.querySelectorAll(
            "._verticalLayout_nw6va_6 label ._textBody_2aowh_10"
          );

          const translations = {
            "Pont des amoureux": "Lovers' bridge",
            "Côte d'amour": "Love coast",
            "Sunset": "Sunset",
            "L'univers": "The universe",
            "Rose sauvage": "Wild rose",
            "Vénus": "Venus",
            "Printemps": "Spring",
            "L'étoile du matin": "The morning star",
            "Pyramide": "Pyramid",
            "Royal": "Royal",
            "Goutte de rose": "Drop of rose",
            "Fleur de peau": "Sensitive skin",
            "Toi et moi": "You and me",
            "Trois élements": "Three elements",
            "Up in the space": "Up in the space",
          };

          labels.forEach((label) => {
            const originalText = label.textContent.trim();
            if (translations[originalText]) {
              label.textContent = translations[originalText];
            }
          });
        }
      }, 600);
    }
    setTimeout(updateTextTranslationsQuote, 400);
  });
  $(document).ready(function () {
    var checkExist = setInterval(function () {
      var $cookieConsent = $(".cb-cookie_consent-container-text_container");
      
      
      if ($cookieConsent.length) {
        var lang = $("html").attr("lang");
        
        if (lang !== "fr") {
          $cookieConsent.html(
            `<svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" 
              style="padding-top: 0px;"><circle cx="7.1167" cy="7" r="6.5" fill="#D6A252" stroke="#C29041">
              </circle>
              <path d="M3.9265 3.46693C3.87025 3.46693 3.81401 3.44546 3.77109 3.40255C3.53545 3.16691 3.53545 2.78347 3.77109 2.54781C3.88525 2.43365 4.03701 2.37079 4.19847 2.37079C4.35991 2.37079 4.51168 2.43366 4.62584 2.54781C4.71166 2.63364 4.71166 2.77279 4.62584 2.85863C4.53999 2.94445 4.40084 2.94446 4.31501 2.85863C4.28388 2.82749 4.24249 2.81034 4.19847 2.81034C4.15444 2.81034 4.11304 2.82749 4.08192 2.85863C4.01764 2.92291 4.01764 3.02748 4.08192 3.09174C4.16776 3.17757 4.16776 3.31672 4.08192 3.40255C4.03899 3.44547 3.98275 3.46693 3.9265 3.46693Z" fill="#C98A2E"></path><path d="M4.19833 3.35961C4.41074 3.35961 4.58294 3.18741 4.58294 2.975C4.58294 2.76259 4.41074 2.59039 4.19833 2.59039C3.98592 2.59039 3.81372 2.76259 3.81372 2.975C3.81372 3.18741 3.98592 3.35961 4.19833 3.35961Z" fill="#674230"></path><path d="M3.81557 2.9381C3.81544 2.93958 3.81531 2.94105 3.81518 2.94254C3.80469 3.06978 3.90923 3.17705 4.03683 3.17242C4.04528 3.17211 4.0538 3.17154 4.06235 3.17067C4.2434 3.15241 4.38857 3.00603 4.40553 2.82485C4.40567 2.82337 4.4058 2.82189 4.40592 2.82042C4.4164 2.69319 4.31186 2.58591 4.18427 2.59054C4.17582 2.59085 4.1673 2.59142 4.15874 2.59229C3.9777 2.61054 3.83253 2.75692 3.81557 2.9381Z" fill="#7A5436"></path>
              <path d="M6.42197 12.6739C6.34464 12.6739 6.26731 12.6444 6.20831 12.5854C5.88434 12.2615 5.88434 11.7343 6.20831 11.4103C6.36526 11.2534 6.5739 11.1669 6.79587 11.1669C7.01783 11.1669 7.22648 11.2534 7.38343 11.4103C7.50143 11.5283 7.50143 11.7196 7.38343 11.8376C7.26541 11.9556 7.0741 11.9556 6.9561 11.8376C6.91329 11.7948 6.85639 11.7712 6.79587 11.7712C6.73535 11.7712 6.67843 11.7948 6.63564 11.8376C6.54727 11.926 6.54727 12.0698 6.63564 12.1581C6.75365 12.2761 6.75365 12.4674 6.63564 12.5854C6.57663 12.6444 6.4993 12.6739 6.42197 12.6739Z" fill="#C98A2E"></path>
              <path d="M6.79574 12.5265C7.08777 12.5265 7.3245 12.2898 7.3245 11.9978C7.3245 11.7057 7.08777 11.469 6.79574 11.469C6.50371 11.469 6.26697 11.7057 6.26697 11.9978C6.26697 12.2898 6.50371 12.5265 6.79574 12.5265Z" fill="#674230"></path><path d="M6.26948 11.947C6.26929 11.9491 6.26912 11.9511 6.26894 11.9531C6.25453 12.1281 6.39825 12.2755 6.57367 12.2692C6.58529 12.2688 6.597 12.268 6.60876 12.2668C6.85768 12.2417 7.05726 12.0404 7.08057 11.7913C7.08076 11.7893 7.08094 11.7873 7.0811 11.7852C7.09552 11.6103 6.9518 11.4628 6.77637 11.4692C6.76476 11.4696 6.75304 11.4704 6.74128 11.4716C6.49238 11.4967 6.2928 11.6979 6.26948 11.947Z" fill="#7A5436"></path><path d="M6.75316 9.36429C6.70532 9.36429 6.65749 9.34603 6.621 9.30954C6.42061 9.10915 6.42061 8.78308 6.621 8.58267C6.71808 8.48559 6.84713 8.43213 6.98444 8.43213C7.12173 8.43213 7.25079 8.48559 7.34787 8.58267C7.42086 8.65566 7.42086 8.774 7.34787 8.84699C7.27487 8.91997 7.15653 8.91998 7.08355 8.84699C7.05707 8.82051 7.02187 8.80593 6.98444 8.80593C6.947 8.80593 6.91179 8.82051 6.88532 8.84699C6.83066 8.90165 6.83066 8.99058 6.88532 9.04522C6.95832 9.11822 6.95832 9.23655 6.88532 9.30954C6.84882 9.34604 6.80099 9.36429 6.75316 9.36429Z" fill="#C98A2E"></path>
              <path d="M6.98442 9.27298C7.16506 9.27298 7.31149 9.12654 7.31149 8.94591C7.31149 8.76527 7.16506 8.61884 6.98442 8.61884C6.80378 8.61884 6.65735 8.76527 6.65735 8.94591C6.65735 9.12654 6.80378 9.27298 6.98442 9.27298Z" fill="#674230"></path><path d="M6.65879 8.91453C6.65867 8.91579 6.65856 8.91704 6.65845 8.9183C6.64954 9.02651 6.73843 9.11773 6.84694 9.11379C6.85413 9.11353 6.86138 9.11304 6.86865 9.11231C7.02262 9.09678 7.14607 8.97229 7.16049 8.81822C7.16061 8.81696 7.16072 8.8157 7.16082 8.81445C7.16973 8.70625 7.08084 8.61502 6.97233 8.61896C6.96514 8.61922 6.95789 8.61971 6.95062 8.62045C6.79666 8.63597 6.67321 8.76045 6.65879 8.91453Z" fill="#7A5436"></path><path d="M11.3606 11.3954C11.3127 11.3954 11.2649 11.3772 11.2284 11.3407C11.028 11.1403 11.028 10.8142 11.2284 10.6138C11.3255 10.5167 11.4546 10.4633 11.5919 10.4633C11.7291 10.4633 11.8582 10.5167 11.9553 10.6138C12.0283 10.6868 12.0283 10.8051 11.9553 10.8781C11.8823 10.9511 11.764 10.9511 11.691 10.8781C11.6645 10.8516 11.6293 10.8371 11.5919 10.8371C11.5544 10.8371 11.5192 10.8516 11.4927 10.8781C11.4381 10.9328 11.4381 11.0217 11.4927 11.0764C11.5657 11.1493 11.5657 11.2677 11.4927 11.3407C11.4562 11.3772 11.4084 11.3954 11.3606 11.3954Z" fill="#C98A2E"></path><path d="M11.5918 11.3045C11.7725 11.3045 11.9189 11.1581 11.9189 10.9775C11.9189 10.7968 11.7725 10.6504 11.5918 10.6504C11.4112 10.6504 11.2648 10.7968 11.2648 10.9775C11.2648 11.1581 11.4112 11.3045 11.5918 11.3045Z" fill="#674230"></path>
              <path d="M11.2662 10.9461C11.2661 10.9473 11.266 10.9486 11.2659 10.9499C11.257 11.0581 11.3459 11.1493 11.4544 11.1453C11.4616 11.1451 11.4688 11.1446 11.4761 11.1439C11.63 11.1283 11.7535 11.0038 11.7679 10.8498C11.768 10.8485 11.7681 10.8473 11.7682 10.846C11.7772 10.7378 11.6883 10.6466 11.5797 10.6505C11.5726 10.6508 11.5653 10.6513 11.558 10.652C11.4041 10.6675 11.2806 10.792 11.2662 10.9461Z" fill="#7A5436"></path>
              <path d="M1.43235 8.86868C1.38452 8.86868 1.33669 8.85043 1.3002 8.81394C1.0998 8.61354 1.0998 8.28747 1.3002 8.08706C1.39728 7.98998 1.52633 7.93652 1.66363 7.93652C1.80093 7.93652 1.92999 7.98999 2.02707 8.08706C2.10006 8.16006 2.10006 8.27839 2.02707 8.35139C1.95407 8.42436 1.83573 8.42437 1.76275 8.35139C1.73627 8.32491 1.70107 8.31032 1.66363 8.31032C1.6262 8.31032 1.59099 8.32491 1.56452 8.35139C1.50986 8.40605 1.50986 8.49497 1.56452 8.54962C1.63752 8.62262 1.63752 8.74095 1.56452 8.81394C1.52802 8.85044 1.48019 8.86868 1.43235 8.86868Z" fill="#C98A2E"></path>
              <path d="M1.66362 8.7778C1.84426 8.7778 1.99069 8.63137 1.99069 8.45073C1.99069 8.27009 1.84426 8.12366 1.66362 8.12366C1.48298 8.12366 1.33655 8.27009 1.33655 8.45073C1.33655 8.63137 1.48298 8.7778 1.66362 8.7778Z" fill="#674230"></path><path d="M1.33799 8.41935C1.33787 8.42061 1.33776 8.42186 1.33765 8.42312C1.32874 8.53133 1.41763 8.62255 1.52614 8.61861C1.53333 8.61835 1.54058 8.61786 1.54785 8.61713C1.70182 8.6016 1.82527 8.47711 1.83969 8.32304C1.83981 8.32178 1.83992 8.32053 1.84002 8.31927C1.84893 8.21107 1.76004 8.11984 1.65153 8.12378C1.64434 8.12404 1.63709 8.12453 1.62982 8.12527C1.47586 8.14079 1.35241 8.26527 1.33799 8.41935Z" fill="#7A5436"></path><path d="M12.1589 8.0366C12.0816 8.0366 12.0042 8.00709 11.9452 7.94809C11.6213 7.62412 11.6213 7.09697 11.9452 6.77297C12.1022 6.61602 12.3108 6.5296 12.5328 6.5296C12.7548 6.5296 12.9634 6.61604 13.1204 6.77297C13.2384 6.89098 13.2384 7.08229 13.1204 7.2003C13.0023 7.31828 12.811 7.3183 12.693 7.2003C12.6502 7.15749 12.5933 7.13391 12.5328 7.13391C12.4723 7.13391 12.4154 7.15749 12.3726 7.2003C12.2842 7.28867 12.2842 7.43244 12.3726 7.52078C12.4906 7.63879 12.4906 7.8301 12.3726 7.94809C12.3136 8.00711 12.2362 8.0366 12.1589 8.0366Z" fill="#C98A2E"></path><path d="M12.5327 7.8892C12.8247 7.8892 13.0614 7.65246 13.0614 7.36043C13.0614 7.0684 12.8247 6.83167 12.5327 6.83167C12.2406 6.83167 12.0039 7.0684 12.0039 7.36043C12.0039 7.65246 12.2406 7.8892 12.5327 7.8892Z" fill="#674230"></path>
              <path d="M12.0064 7.31013C12.0062 7.31217 12.0061 7.31419 12.0059 7.31623C11.9915 7.49117 12.1352 7.63864 12.3106 7.63228C12.3222 7.63185 12.3339 7.63106 12.3457 7.62987C12.5946 7.60477 12.7942 7.40352 12.8175 7.15443C12.8177 7.15239 12.8179 7.15036 12.818 7.14834C12.8325 6.97341 12.6887 6.82593 12.5133 6.83229C12.5017 6.83272 12.49 6.83351 12.4782 6.8347C12.2293 6.85979 12.0297 7.06104 12.0064 7.31013Z" fill="#7A5436"></path>
              <path d="M9.13172 6.3937C9.02339 6.3937 8.91507 6.35237 8.83243 6.26973C8.37861 5.81591 8.37861 5.07748 8.83243 4.62362C9.05228 4.40377 9.34454 4.28271 9.65548 4.28271C9.96639 4.28271 10.2587 4.40379 10.4785 4.62362C10.6438 4.78893 10.6438 5.05692 10.4785 5.22222C10.3132 5.38749 10.0452 5.38751 9.87993 5.22222C9.81996 5.16226 9.74026 5.12923 9.65548 5.12923C9.5707 5.12923 9.49097 5.16226 9.43103 5.22222C9.30723 5.34602 9.30723 5.5474 9.43103 5.67115C9.59633 5.83646 9.59633 6.10444 9.43103 6.26973C9.34836 6.35239 9.24004 6.3937 9.13172 6.3937Z" fill="#C98A2E"></path><path d="M9.65537 6.18751C10.0644 6.18751 10.3961 5.85589 10.3961 5.44681C10.3961 5.03774 10.0644 4.70612 9.65537 4.70612C9.24629 4.70612 8.91467 5.03774 8.91467 5.44681C8.91467 5.85589 9.24629 6.18751 9.65537 6.18751Z" fill="#674230"></path><path d="M8.91805 5.37574C8.91778 5.3786 8.91754 5.38143 8.91729 5.38429C8.8971 5.62935 9.09842 5.83593 9.34415 5.82701C9.36042 5.82641 9.37684 5.8253 9.39331 5.82364C9.74199 5.78847 10.0216 5.50656 10.0542 5.15764C10.0545 5.15478 10.0547 5.15195 10.055 5.14911C10.0752 4.90408 9.87383 4.69748 9.6281 4.70639C9.61183 4.70699 9.59541 4.7081 9.57894 4.70976C9.23028 4.74491 8.95071 5.02682 8.91805 5.37574Z" fill="#7A5436">
              </path><path d="M7.19268 3.7212C7.0624 3.7212 6.93211 3.67149 6.83271 3.57209C6.28688 3.02626 6.28688 2.1381 6.83271 1.59222C7.09714 1.3278 7.44866 1.18219 7.82264 1.18219C8.1966 1.18219 8.54815 1.32782 8.81258 1.59222C9.01138 1.79105 9.01138 2.11337 8.81258 2.31219C8.61373 2.51097 8.29141 2.511 8.09261 2.31219C8.02048 2.24007 7.92461 2.20034 7.82264 2.20034C7.72067 2.20034 7.62478 2.24007 7.55268 2.31219C7.40379 2.46108 7.40379 2.7033 7.55268 2.85214C7.75151 3.05097 7.75151 3.37329 7.55268 3.57209C7.45326 3.67151 7.32297 3.7212 7.19268 3.7212Z" fill="#C98A2E"></path>
              <path d="M7.82252 3.47322C8.31454 3.47322 8.7134 3.07436 8.7134 2.58234C8.7134 2.09033 8.31454 1.69147 7.82252 1.69147C7.3305 1.69147 6.93164 2.09033 6.93164 2.58234C6.93164 3.07436 7.3305 3.47322 7.82252 3.47322Z" fill="#674230"></path><path d="M6.9357 2.49687C6.93538 2.5003 6.93508 2.50371 6.93479 2.50715C6.9105 2.80189 7.15264 3.05036 7.4482 3.03963C7.46777 3.03892 7.48751 3.03758 7.50732 3.03558C7.9267 2.99328 8.26295 2.65421 8.30224 2.23454C8.30256 2.23111 8.30285 2.2277 8.30313 2.22429C8.32741 1.92957 8.08527 1.68108 7.78971 1.6918C7.77015 1.69252 7.7504 1.69385 7.73059 1.69585C7.31124 1.73813 6.97499 2.0772 6.9357 2.49687Z" fill="#7A5436"></path><path d="M5.32984 7.37765C5.22151 7.37765 5.11319 7.33632 5.03055 7.25368C4.57673 6.79986 4.57673 6.06143 5.03055 5.60757C5.2504 5.38772 5.54266 5.26666 5.8536 5.26666C6.16451 5.26666 6.4568 5.38774 6.67665 5.60757C6.84194 5.77288 6.84194 6.04086 6.67665 6.20617C6.51132 6.37144 6.24334 6.37146 6.07805 6.20617C6.01808 6.14621 5.93838 6.11317 5.8536 6.11317C5.76882 6.11317 5.68909 6.14621 5.62915 6.20617C5.50535 6.32996 5.50535 6.53135 5.62915 6.6551C5.79445 6.82041 5.79445 7.08839 5.62915 7.25368C5.54648 7.33634 5.43816 7.37765 5.32984 7.37765Z" fill="#C98A2E"></path><path d="M5.85349 7.17145C6.26256 7.17145 6.59418 6.83983 6.59418 6.43076C6.59418 6.02168 6.26256 5.69006 5.85349 5.69006C5.44441 5.69006 5.11279 6.02168 5.11279 6.43076C5.11279 6.83983 5.44441 7.17145 5.85349 7.17145Z" fill="#674230"></path>
              <path d="M5.11629 6.36012C5.11603 6.36297 5.11578 6.36581 5.11553 6.36866C5.09534 6.61372 5.29666 6.8203 5.54239 6.81138C5.55866 6.81079 5.57508 6.80968 5.59155 6.80802C5.94023 6.77285 6.2198 6.49094 6.25246 6.14201C6.25273 6.13916 6.25297 6.13632 6.2532 6.13349C6.27339 5.88845 6.07207 5.68185 5.82634 5.69077C5.81007 5.69136 5.79366 5.69247 5.77718 5.69414C5.42853 5.72929 5.14896 6.0112 5.11629 6.36012Z" fill="#7A5436"></path>
              <path d="M3.45587 10.7117C3.33381 10.7117 3.21175 10.6651 3.11863 10.572C2.60727 10.0606 2.60727 9.22855 3.11863 8.71715C3.36636 8.46942 3.69568 8.33301 4.04605 8.33301C4.39639 8.33301 4.72574 8.46944 4.97346 8.71715C5.15971 8.90342 5.15971 9.20538 4.97346 9.39165C4.78717 9.57788 4.48521 9.5779 4.29896 9.39165C4.23139 9.32408 4.14158 9.28686 4.04605 9.28686C3.95051 9.28686 3.86068 9.32408 3.79313 9.39165C3.65364 9.53114 3.65364 9.75806 3.79313 9.8975C3.9794 10.0838 3.9794 10.3857 3.79313 10.572C3.69999 10.6651 3.57793 10.7117 3.45587 10.7117Z" fill="#C98A2E"></path><path d="M4.04604 10.4795C4.50699 10.4795 4.88066 10.1058 4.88066 9.64486C4.88066 9.18391 4.50699 8.81024 4.04604 8.81024C3.5851 8.81024 3.21143 9.18391 3.21143 9.64486C3.21143 10.1058 3.5851 10.4795 4.04604 10.4795Z" fill="#674230"></path><path d="M3.2152 9.56478C3.2149 9.568 3.21462 9.57119 3.21434 9.57441C3.19159 9.85054 3.41844 10.0833 3.69533 10.0733C3.71367 10.0726 3.73216 10.0713 3.75073 10.0695C4.14361 10.0298 4.45863 9.71219 4.49544 9.31902C4.49574 9.3158 4.49602 9.31261 4.49627 9.30941C4.51903 9.03331 4.29218 8.80051 4.01528 8.81056C3.99695 8.81123 3.97845 8.81248 3.95989 8.81435C3.56702 8.85396 3.25201 9.17162 3.2152 9.56478Z" fill="#7A5436"></path>
              <path d="M9.02443 10.7315C8.88559 10.7315 8.74675 10.6785 8.64083 10.5726C8.05918 9.99092 8.05918 9.04447 8.64083 8.46276C8.92261 8.18098 9.2972 8.02582 9.69573 8.02582C10.0942 8.02582 10.4689 8.18101 10.7506 8.46276C10.9625 8.67464 10.9625 9.01811 10.7506 9.22998C10.5387 9.44181 10.1953 9.44183 9.98341 9.22998C9.90655 9.15313 9.80439 9.11079 9.69573 9.11079C9.58707 9.11079 9.48488 9.15313 9.40805 9.22998C9.24939 9.38865 9.24939 9.64676 9.40805 9.80537C9.61993 10.0172 9.61993 10.3607 9.40805 10.5726C9.3021 10.6785 9.16326 10.7315 9.02443 10.7315Z" fill="#C98A2E"></path>
              <path d="M9.69556 10.4671C10.2199 10.4671 10.6449 10.0421 10.6449 9.51777C10.6449 8.99346 10.2199 8.56842 9.69556 8.56842C9.17125 8.56842 8.74622 8.99346 8.74622 9.51777C8.74622 10.0421 9.17125 10.4671 9.69556 10.4671Z" fill="#674230"></path>
              <path d="M8.75057 9.42668C8.75023 9.43034 8.74991 9.43397 8.74959 9.43763C8.72371 9.75172 8.98174 10.0165 9.2967 10.0051C9.31755 10.0043 9.33859 10.0029 9.35971 10.0007C9.8066 9.95567 10.1649 9.59435 10.2068 9.14714C10.2071 9.14348 10.2074 9.13984 10.2077 9.13621C10.2336 8.82215 9.97559 8.55735 9.66063 8.56878C9.63978 8.56954 9.61874 8.57096 9.59762 8.5731C9.15076 8.61815 8.79243 8.97947 8.75057 9.42668Z" fill="#7A5436"></path>
              <path d="M2.5414 6.21498C2.46406 6.21498 2.38672 6.18547 2.32772 6.12647C2.00372 5.80246 2.00372 5.27525 2.32772 4.95122C2.48468 4.79426 2.69335 4.70782 2.91534 4.70782C3.13732 4.70782 3.346 4.79427 3.50297 4.95122C3.62098 5.06924 3.62098 5.26057 3.50297 5.37859C3.38493 5.49659 3.1936 5.4966 3.07559 5.37859C3.03278 5.33578 2.97587 5.3122 2.91534 5.3122C2.85481 5.3122 2.79789 5.33578 2.75509 5.37859C2.66671 5.46698 2.66671 5.61075 2.75509 5.69911C2.87312 5.81713 2.87312 6.00846 2.75509 6.12647C2.69607 6.18549 2.61874 6.21498 2.5414 6.21498Z" fill="#C98A2E"></path><path d="M2.9153 6.06754C3.20736 6.06754 3.44412 5.83077 3.44412 5.53871C3.44412 5.24665 3.20736 5.00989 2.9153 5.00989C2.62324 5.00989 2.38647 5.24665 2.38647 5.53871C2.38647 5.83077 2.62324 6.06754 2.9153 6.06754Z" fill="#674230"></path><path d="M2.38899 5.48797C2.3888 5.49001 2.38863 5.49204 2.38845 5.49407C2.37403 5.66903 2.51777 5.81652 2.69321 5.81016C2.70483 5.80973 2.71654 5.80894 2.72831 5.80775C2.97725 5.78264 3.17685 5.58137 3.20017 5.33226C3.20036 5.33022 3.20053 5.32819 3.20069 5.32617C3.21511 5.15122 3.07138 5.00372 2.89593 5.01009C2.88432 5.01051 2.8726 5.0113 2.86084 5.01249C2.61191 5.03759 2.41231 5.23886 2.38899 5.48797Z" fill="#7A5436"></path><path d="M11.7014 4.5624C11.8558 4.5624 11.981 4.43724 11.981 4.28285C11.981 4.12846 11.8558 4.0033 11.7014 4.0033C11.547 4.0033 11.4219 4.12846 11.4219 4.28285C11.4219 4.43724 11.547 4.5624 11.7014 4.5624Z" fill="#AD712C"></path><path d="M7.68702 7.08956C7.84142 7.08956 7.96658 6.9644 7.96658 6.81001C7.96658 6.65562 7.84142 6.53046 7.68702 6.53046C7.53263 6.53046 7.40747 6.65562 7.40747 6.81001C7.40747 6.9644 7.53263 7.08956 7.68702 7.08956Z" fill="#AD712C"></path>
              <path d="M5.68531 4.5624C5.83971 4.5624 5.96487 4.43724 5.96487 4.28285C5.96487 4.12846 5.83971 4.0033 5.68531 4.0033C5.53092 4.0033 5.40576 4.12846 5.40576 4.28285C5.40576 4.43724 5.53092 4.5624 5.68531 4.5624Z" fill="#AD712C"></path>
              <path d="M3.19166 7.21261C3.34605 7.21261 3.47121 7.08745 3.47121 6.93306C3.47121 6.77866 3.34605 6.6535 3.19166 6.6535C3.03727 6.6535 2.91211 6.77866 2.91211 6.93306C2.91211 7.08745 3.03727 7.21261 3.19166 7.21261Z" fill="#AD712C"></path><path d="M2.50953 4.03689C2.66393 4.03689 2.78909 3.91173 2.78909 3.75734C2.78909 3.60294 2.66393 3.47778 2.50953 3.47778C2.35514 3.47778 2.22998 3.60294 2.22998 3.75734C2.22998 3.91173 2.35514 4.03689 2.50953 4.03689Z" fill="#AD712C"></path>
              <path d="M5.12623 1.96816C5.28062 1.96816 5.40579 1.843 5.40579 1.68861C5.40579 1.53422 5.28062 1.40906 5.12623 1.40906C4.97184 1.40906 4.84668 1.53422 4.84668 1.68861C4.84668 1.843 4.97184 1.96816 5.12623 1.96816Z" fill="#AD712C"></path><path d="M9.93458 2.65005C10.089 2.65005 10.2141 2.52489 10.2141 2.3705C10.2141 2.2161 10.089 2.09094 9.93458 2.09094C9.78019 2.09094 9.65503 2.2161 9.65503 2.3705C9.65503 2.52489 9.78019 2.65005 9.93458 2.65005Z" fill="#AD712C"></path><path d="M8.917 3.91384C9.0714 3.91384 9.19656 3.78868 9.19656 3.63429C9.19656 3.4799 9.0714 3.35474 8.917 3.35474C8.76261 3.35474 8.63745 3.4799 8.63745 3.63429C8.63745 3.78868 8.76261 3.91384 8.917 3.91384Z" fill="#AD712C"></path><path d="M10.337 7.21261C10.4914 7.21261 10.6166 7.08745 10.6166 6.93306C10.6166 6.77866 10.4914 6.6535 10.337 6.6535C10.1827 6.6535 10.0575 6.77866 10.0575 6.93306C10.0575 7.08745 10.1827 7.21261 10.337 7.21261Z" fill="#AD712C"></path><path d="M9.8318 11.8645C9.98619 11.8645 10.1114 11.7393 10.1114 11.5849C10.1114 11.4305 9.98619 11.3054 9.8318 11.3054C9.67741 11.3054 9.55225 11.4305 9.55225 11.5849C9.55225 11.7393 9.67741 11.8645 9.8318 11.8645Z" fill="#AD712C"></path>
              <path d="M11.8234 9.33773C11.9778 9.33773 12.1029 9.21257 12.1029 9.05818C12.1029 8.90379 11.9778 8.77863 11.8234 8.77863C11.669 8.77863 11.5438 8.90379 11.5438 9.05818C11.5438 9.21257 11.669 9.33773 11.8234 9.33773Z" fill="#AD712C"></path>
              <path d="M6.86915 10.5468C7.02354 10.5468 7.14871 10.4217 7.14871 10.2673C7.14871 10.1129 7.02354 9.98773 6.86915 9.98773C6.71476 9.98773 6.5896 10.1129 6.5896 10.2673C6.5896 10.4217 6.71476 10.5468 6.86915 10.5468Z" fill="#AD712C"></path><path d="M5.79896 8.49563C5.95335 8.49563 6.07851 8.37047 6.07851 8.21608C6.07851 8.06168 5.95335 7.93652 5.79896 7.93652C5.64457 7.93652 5.51941 8.06168 5.51941 8.21608C5.51941 8.37047 5.64457 8.49563 5.79896 8.49563Z" fill="#AD712C"></path><path d="M1.94471 10.1999C2.09911 10.1999 2.22427 10.0748 2.22427 9.92036C2.22427 9.76597 2.09911 9.64081 1.94471 9.64081C1.79032 9.64081 1.66516 9.76597 1.66516 9.92036C1.66516 10.0748 1.79032 10.1999 1.94471 10.1999Z" fill="#AD712C"></path><path d="M3.92628 11.8743C4.08067 11.8743 4.20583 11.7491 4.20583 11.5947C4.20583 11.4403 4.08067 11.3152 3.92628 11.3152C3.77189 11.3152 3.64673 11.4403 3.64673 11.5947C3.64673 11.7491 3.77189 11.8743 3.92628 11.8743Z" fill="#AD712C"></path><path d="M8.24635 11.5376C8.40074 11.5376 8.5259 11.4125 8.5259 11.2581C8.5259 11.1037 8.40074 10.9785 8.24635 10.9785C8.09196 10.9785 7.9668 11.1037 7.9668 11.2581C7.9668 11.4125 8.09196 11.5376 8.24635 11.5376Z" fill="#AD712C"></path>
              <path d="M8.3058 12.9544C8.46019 12.9544 8.58535 12.8292 8.58535 12.6748C8.58535 12.5204 8.46019 12.3953 8.3058 12.3953C8.1514 12.3953 8.02625 12.5204 8.02625 12.6748C8.02625 12.8292 8.1514 12.9544 8.3058 12.9544Z" fill="#AD712C"></path>
              <path d="M5.41261 11.2603C5.567 11.2603 5.69216 11.1352 5.69216 10.9808C5.69216 10.8264 5.567 10.7012 5.41261 10.7012C5.25822 10.7012 5.13306 10.8264 5.13306 10.9808C5.13306 11.1352 5.25822 11.2603 5.41261 11.2603Z" fill="#AD712C"></path><path d="M1.27955 6.63113C1.43394 6.63113 1.55911 6.50597 1.55911 6.35157C1.55911 6.19718 1.43394 6.07202 1.27955 6.07202C1.12516 6.07202 1 6.19718 1 6.35157C1 6.50597 1.12516 6.63113 1.27955 6.63113Z" fill="#AD712C"></path>
              <path d="M7.40748 5.33401C7.56187 5.33401 7.68704 5.20885 7.68704 5.05446C7.68704 4.90006 7.56187 4.7749 7.40748 4.7749C7.25309 4.7749 7.12793 4.90006 7.12793 5.05446C7.12793 5.20885 7.25309 5.33401 7.40748 5.33401Z" fill="#AD712C"></path><path d="M4.29884 5.53524C4.45323 5.53524 4.57839 5.41008 4.57839 5.25569C4.57839 5.1013 4.45323 4.97614 4.29884 4.97614C4.14445 4.97614 4.01929 5.1013 4.01929 5.25569C4.01929 5.41008 4.14445 5.53524 4.29884 5.53524Z" fill="#AD712C"></path></svg>
              This site uses cookies to enhance your browsing experience. By continuing to browse, you agree to the use of cookies as described on the following page: 
              <a style="text-decoration: underline;" class="cb-cookie_consent-container-link_container is--checked-link" target="_blank" href="/en/pages/politique-de-cookies">Cookie Policy</a>`
          );
          $(".cb-cookie_consent-container-button").text("I ACCEPT");
        }
        clearInterval(checkExist);
      }
    }, 100);
  });
  $(document).ready(function() {
    var lang = $('html').attr('lang') || 'en';
    
    var targetDiv = $('.gzr4Gu1MED div div').filter(function() {
      return $(this).text().trim() === "No products found!";
    });
    
    if (targetDiv.length) {
      if (lang === 'fr') {
        targetDiv.text('Aucun produit trouvé !');
      } else{
        targetDiv.text('No products found!');
      }
    }
  });
  $(document).ready(function() {
      if ($('html').attr('lang') === 'en') {
        $.getJSON('/cart.js', function(cart) {
          var itemsToUpdate = cart.items.filter(function(item) {
            return item.properties && item.properties.hasOwnProperty('taille');
          });
    
          if (itemsToUpdate.length === 0) {
            return;
          }
    
          var ajaxCalls = [];
    
          function updateNextItem() {
            if (itemsToUpdate.length === 0) {
              $.when.apply($, ajaxCalls).then(function () {
                const event = new Event("cart:refresh");
                document.dispatchEvent(event);
              });
    
              return;
            }
    
            var item = itemsToUpdate.shift();
            var tailleValue = item.properties['taille'];
            var line = item.line || findLine(item, cart.items);
    
            var removePromise = $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: {
                line: line,
                quantity: 0
              }
            }).fail(function() {
              console.error('Failed to remove item line ' + line);
            });
    
            ajaxCalls.push(removePromise);
    
            removePromise.done(function() {
              var newProperties = $.extend({}, item.properties);
              delete newProperties['taille'];
              newProperties['size'] = tailleValue;
    
              var addPromise = $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: {
                  id: item.variant_id,
                  quantity: item.quantity,
                  properties: newProperties
                }
              }).fail(function() {
                console.error('Failed to add updated item ' + item.variant_id);
              });
    
              ajaxCalls.push(addPromise);
    
              addPromise.done(function() {
                updateNextItem();
              }).fail(function() {
                updateNextItem();
              });
            }).fail(function() {
              updateNextItem();
            });
          }
    
          function findLine(targetItem, items) {
            for (var i = 0; i < items.length; i++) {
              if (items[i].key === targetItem.key) return i + 1;
            }
            return 1; 
          }
    
          updateNextItem();
        });
      }
    });



  
});
